// import React, { useEffect, useState } from 'react';
// import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
// import { ConstantActions } from '../../../Services/_actions/index.js';
// import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
// import { PaginatedResponse } from '../../../interfaces/Management.interface.ts';
// import { useRecoilValue } from 'recoil';
// import { userInformationAtom } from '../../../Services/_states/auth.js';

// interface OrganisationDropdownProps {
//     value: any;
//     onChange: (value: any) => void;
//     error?: boolean;
//     errorMessage?: string;
//     label?: any;
//     disabled?: boolean;
//     sx?: any;
//     categoryType?:string;
// }

// const OrganisationDropdown: React.FC<OrganisationDropdownProps> = ({
//     categoryType="",
//     value,
//     onChange,
//     error = false,
//     errorMessage = '',
//     label = 'Select Organisation',
//     disabled = false,
//     sx = { mb: 1, mt: 1 }
// }) => {
//     const loggedInUser = useRecoilValue(userInformationAtom);
//     const { showSnackBar } = useSnackBar();
//     const constantActions = ConstantActions();
//     const [organisationRes, setOrganisationRes] = useState<PaginatedResponse>({ list: [], pages: 0, count: 0 });
//     const [organisationFilter, setOrganisationFilter] = useState({ page: 0, search: '',category:"" });
//     const [organisationIsLoading, setOrganisationIsLoading] = useState(false);

//     const fetchOrganisations = async (filterObj) => {
//         setOrganisationIsLoading(true);
//         try {
//             const res = await constantActions.getOrganisationsWithPagination(filterObj);
//             if (res?.status === 200 && res?.data) {
//                 setOrganisationRes(res.data);
//                 setOrganisationFilter({ ...organisationFilter, page: organisationFilter?.page + 1 })
//             } else {
//                 showSnackBar('Unexpected response status or data:', 'error');
//             }
//         } catch (error) {
//             showSnackBar('Failed to fetch organizations:', 'error');
//         }
//         setOrganisationIsLoading(false);
//     };

//     const loadMoreOrganisation = async () => {
//         if (organisationFilter.page < (organisationRes.pages || 0)) {
//             setOrganisationIsLoading(true);
//             let listData: any[] = Array.isArray(organisationRes.list) ? [...organisationRes.list] : [];
//             const data = { ...organisationFilter, page: organisationFilter.page + 1 };
//             try {
//                 const res = await constantActions.getOrganisationsWithPagination(data);
//                 if (res?.status === 200 && res?.data?.list && Array.isArray(res.data.list)) {
//                     listData = [...listData, ...res.data.list];
//                     setOrganisationRes({ ...res.data, list: listData });
//                     setOrganisationFilter(data);
//                 } else {
//                     showSnackBar('Unexpected response structure or status:', 'error');
//                 }
//             } catch (error) {
//                 showSnackBar('Error loading more organizations:', 'error');
//             } finally {
//                 setOrganisationIsLoading(false);
//             }
//         }
//     };

//     const handleSearchOrganisation = (query) => {
//         const updatedFilter = { ...organisationFilter, search: query || '', page: 0 };
//         setOrganisationFilter(updatedFilter);
//         fetchOrganisations(updatedFilter);
//     };

//     useEffect(() => {
//         if (loggedInUser.is_superuser) {
//             if(categoryType?.length>0){
//                 setOrganisationFilter({...organisationFilter,category:categoryType})
//                 fetchOrganisations({...organisationFilter,category:categoryType});
//             } else {
//                 fetchOrganisations(organisationFilter);
//             }
//         } else {
//             setOrganisationRes({ list: [loggedInUser?.profile?.organisation], pages: 1, count: 1 });
//         }
//     }, [categoryType]);

//     return (
//         <SearchableDropdown
//             options={organisationRes?.list || []}
//             label={label}
//             value={value}
//             fetchMoreOptions={organisationFilter.page < (organisationRes?.pages || 0) ? loadMoreOrganisation : undefined}
//             onSearch={handleSearchOrganisation}
//             labelKey="name"
//             valueKey="organisation_id"
//             onChange={onChange}
//             loading={organisationIsLoading}
//             error={error}
//             errorMessage={errorMessage}
//             disabled={disabled}
//             sx={sx}
//         />
//     );
// };

// export default OrganisationDropdown;
import React, { useEffect, useState } from 'react';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ConstantActions } from '../../../Services/_actions/index.js';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { PaginatedResponse } from '../../../interfaces/Management.interface.ts';
import { useRecoilState, useRecoilValue, useRecoilValueLoadable, useResetRecoilState } from 'recoil';
import { userInformationAtom } from '../../../Services/_states/auth.js';
import { organisationTableStateAtom } from '../../../Services/_states/index.js';
import { fetchOrganisationsSelector } from '../../../Services/_states/Organisation/organisationSelector.ts';
import { generateFilterKey } from '../../../utils/helper.jsx';
import useDebounce from '../../Shared/Delay/index.tsx'
interface OrganisationDropdownProps {
    value: any;
    onChange: (value: any) => void;
    error?: boolean;
    errorMessage?: string;
    label?: any;
    disabled?: boolean;
    sx?: any;
    categoryType?: string;
    className?: string;
    autoSelectValue?: boolean;
}

const OrganisationDropdown: React.FC<OrganisationDropdownProps> = ({
    categoryType = "",
    value,
    onChange,
    error = false,
    errorMessage = '',
    label = 'Select Organisation',
    disabled = false,
    sx = { mb: 1, mt: 1 },
    className = "",
    autoSelectValue = true,
}) => {
    const loggedInUser = useRecoilValue(userInformationAtom);
    const { showSnackBar } = useSnackBar();
    const [tableState, setTableState] = useRecoilState(organisationTableStateAtom);
    const fetchedData = useRecoilValueLoadable(fetchOrganisationsSelector);
    const [filteredOrg, setFilteredOrg] = useState<any>([]);
    const [searchQuery, setSearchQuery] = useState(''); // Local state for search input
    const debouncedSearchQuery = useDebounce(searchQuery, 500); // Debounce the search query

    useEffect(() => {
        return () => {
            setSearchQuery('');

            setTableState((prev) => ({
                ...prev,
                filters: {
                    ...prev.filters,
                    search: '',
                    page: 0,
                },
            }));
        };
    }, []);

    useEffect(() => {
        if (!loggedInUser) {
            return; // If loggedInUser is not available, don't proceed
        }
        if (fetchedData.state === "hasValue" && !fetchedData.contents.fromCache) {
            const filterKey = generateFilterKey(tableState.filters);
            setTableState((prev) => ({
                ...prev,
                cache: { ...prev.cache, [filterKey]: fetchedData.contents.data },
                totalCountCache: { ...prev.totalCountCache, [filterKey]: fetchedData.contents.totalCount },
            }));
        }
    }, [fetchedData, setTableState, loggedInUser]);

    useEffect(() => {
        if (!loggedInUser?.is_superuser) return;

        const allValues = Object?.values(tableState?.cache)?.flat();
        const organisations = allValues?.reduce((accumulator: any, current: any) => {
            if (!accumulator.some(item => item?.organisation_id === current?.organisation_id)) {
                accumulator.push(current);
            }
            return accumulator;
        }, []);
        setFilteredOrg(organisations);
    }, [tableState, loggedInUser]);


    useEffect(() => {
        if (debouncedSearchQuery) {
            setTableState((prev) => ({
                ...prev,
                filters: { ...prev.filters, search: debouncedSearchQuery, page: 0 },
            }));
        }
    }, [debouncedSearchQuery, setTableState]);
    const loadMoreOrganisation = async () => {
        const currentKey = generateFilterKey(tableState.filters);
        const totalCount = tableState.totalCountCache[currentKey] || 0;
        const allCachedValues = Object.entries(tableState.cache)
            .filter(([key]) => key.includes(`search=${tableState.filters.search || ''}`))
            .flatMap(([_, val]: any) => val); // flatten the arrays

        const currentLength = allCachedValues.length;

        if (totalCount > currentLength) {
            setTableState((prev) => ({
                ...prev,
                filters: {
                    ...prev.filters,
                    page: prev.filters.page + 1,
                },
            }));
        }
    };

    useEffect(() => {
        if (!loggedInUser) return;
        if (loggedInUser.is_superuser) {
            if (categoryType?.length > 0) {
                setTableState((prev) => ({
                    ...prev,
                    filters: { ...prev.filters, category: categoryType },
                }));
            }
        } else {
            setFilteredOrg([loggedInUser?.profile?.organisation]);
            if (autoSelectValue) {
                onChange(loggedInUser?.profile?.organisation);
            }
        }
    }, [categoryType, loggedInUser]);

    const handleSearchOrganisation = (query: string) => {
        setSearchQuery(query); // Update the local search state
    };
    return (
        <SearchableDropdown
            options={(searchQuery ? tableState?.cache[generateFilterKey(tableState?.filters)] : filteredOrg) || []}
            // options={(tableState?.filters?.search ? tableState?.cache[generateFilterKey(tableState?.filters)] : filteredOrg) || []}
            label={label}
            value={value}
            fetchMoreOptions={loadMoreOrganisation}
            onSearch={handleSearchOrganisation}
            labelKey="name"
            valueKey="organisation_id"
            onChange={onChange}
            loading={fetchedData.state === "loading"}
            error={error}
            errorMessage={errorMessage}
            disabled={disabled}
            sx={sx}
            className={className || ''}
            searchValue={searchQuery} // Pass the local search value to the dropdown
        />
    );
};

export default OrganisationDropdown;
